import {addStyle} from "./svgHelper";
import layoutStyles from "./layoutStyles";
import "@babel/polyfill";
import * as d3 from "d3";

function strToLocale(num){return num.toString().replace('.',',');}

export default function (target, colors, barsData,options) {
    // set the dimensions and margins of the graph
    const margin = {top: 150, right: 60, bottom: 150, left: 60};
    if(options && options.margin){
        margin.top = options.margin.top || margin.top;
        margin.bottom = options.margin.bottom || margin.bottom;
        margin.left = options.margin.left || margin.left;
        margin.right = options.margin.right || margin.right;
    }

    const   width = 1024 - margin.left - margin.right;
    const  height = 576 - margin.top - margin.bottom - 38;

    var axisOffset = 10;

    // append the svg object to the body of the page
    const data = barsData.values;
    const svg = d3.select(target)
        .attr("preserveAspectRatio", "xMidYMin slice")
        .attr("viewBox", "0 0 1024 576");

    // X axis
    const x = d3
        .scaleBand()
        .range([0, width])
        .domain(
            data.map(function (d) {
                return d.name;
            })
        )
        .padding(0.2);
    // Add Y axis
    const max = data.reduce((old, item) => (item.value > old ? item.value : old), 0);

    const y = d3.scaleLinear().domain([0, max]).range([height, 0]);

    // BG

    if(!options || options.background) {
        svg.style('background', 'rgb(206,211,217)')
            .style('background', 'linear-gradient(180deg, rgba(206,211,217,1) 0%, rgba(233,234,238,1) 50%, rgba(206,211,217,1) 100%)')

        // SWR LOGO
        svg.append('image')
            .attr("href", "resources/SWR_Aktuell_Logo_2Z_RGB_Weiss.svg")
            .attr("x", margin.left)
            .attr("y", 20)
            .attr("width", 100)
            .attr("height", 60);
    }

    if(!options || !options.header) {
        // Kicker
        let kickerPrefix = '';
        let kickerText = barsData.kicker;
        let kickerKeyword = 'bundestagswahl';
        if (barsData.kicker.toLowerCase().includes(kickerKeyword)) {
            const keyWordIndex = barsData.kicker.toLowerCase().indexOf(kickerKeyword);
            kickerPrefix = barsData.kicker.substring(keyWordIndex, kickerKeyword.length);
            kickerText = barsData.kicker.substring(kickerKeyword.length, barsData.kicker.length);
        }
        const kicker = svg.append("text")
            .attr("x", margin.left + width)
            .attr("y", margin.top - 80);

        kicker
            .append('tspan')
            .call(addStyle, layoutStyles.headline)
            .text(kickerPrefix);

        kicker.append('tspan')
            .style("font-weight", "400")
            .style("font-family", options.fontFamily || "TheMix")
            .style("font-size", "24px")
            .style("fill", "#00183a")
            .text(kickerText);

        svg
            .append("rect")
            .attr("x", margin.left)
            .attr("y", margin.top - 70)
            .attr("fill", "white")
            .attr("width", width)
            .attr("height", 2);

        // Subheadline
        /*svg
            .append("text")
            .style("color", "white")
            .style("font-weight", "400")
            .style("text-anchor", "center")
            .attr("x", margin.left)
            .attr("y", margin.top - 44)
            .attr("font-family", options.fontFamily || "TheMix")
            .attr("font-size", "24px")
            .attr("fill", "#00183a")
            .text("Die");
        svg
            .append("text")
            .style("color", "white")
            .style("font-weight", "500")
            .style("text-anchor", "start")
            .attr("x", margin.left + 40)
            .attr("y", margin.top - 44)
            .attr("font-family", options.fontFamily || "TheMix")
            .attr("font-size", "24px")
            .attr("fill", "#00183a")
            .text("Wahl");*/

        svg
            .append("text")
            .style("text-anchor", "start")
            .attr("x", margin.left)
            .attr("y", margin.top - 44)
            .style("font-weight", "400")
            .attr("font-family", options.fontFamily || "TheMix")
            .attr("font-size", "20px")
            .attr("fill", "#00183a")
            .text(barsData.category + ' ' + barsData.headline + ' ' + barsData.infoText);
    }
    else{
        options.header.forEach(item=>{
            const el = svg.append(item.type)
                .attr("width", item.width)
                .attr("height", item.height)
                .attr("x",item.x)
                .attr("y", item.y)
                .call(addStyle, item.style);
            if(item.type === 'text'){
                if(item.render){
                    el.text(item.render(barsData));
                }
                else if(item.info){
                    el.text(item.text + barsData.infoText);
                }
                else{
                    el.text(item.text);
                }
            }
        });
    }
    var barGroup = d3
        .select(target)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    // Transparent BG
    if(!options || options.background){
        barGroup
            .append("rect")
            .attr("width", width)
            .attr("height", height + 44)
            .attr("x", 0)
            .attr("y", -30)
            .attr("fill", "white")
            .style("opacity", 0.1);
    }
    else{
        barGroup
            .append("rect")
            .attr("width", width)
            .attr("height", height + 31)
            .attr("x", 0)
            .attr("y", -30)
            .attr("fill", "url('#MyGradient')");
    }
    if(options && !options.header){
        barGroup
            .append("rect")
            .attr("width", width)
            .attr("height", 5)
            .attr("x", 0)
            .attr("y", -35)
            .attr("fill", "rgb(232, 82, 54)");
    }

    /// INDI LOGO
    /*    svg
            .append("image")
            .attr("href", "resources/logo.png")
            .attr("x", margin.left + width - 145)
            .attr("y", 540)
            .attr("fill", "white")
            .style("width", "auto")
            .style("height", "16px");*/
    if(barsData.createdTS.length > 0 ){
        options.timestamp = options.timestamp ? options.timestamp : {label:{}};
        const time = svg.append('text')
            .style("font-weight",options.timestamp.fontWeight || "400")
            .style("text-anchor", "start")
            .style("font-family", options.fontFamily || "TheMix")
            .style("font-size", options.timestamp.fontSize || "14px")
            .style("fill", options.timestamp.color || "#00183a")
            .attr("x", options.timestamp.x || margin.left)
            .attr("y", options.timestamp.y || 553);
        time.append('tspan')
            .style('font-weight', options.timestamp.label.fontWeight || '800')
            .style("font-size", options.timestamp.label.fontSize || "14px")
            .text('Stand: ');
        time.append('tspan')
            .style("font-size", options.timestamp.fontSize || "14px")
            .text(barsData.createdTS);
    }

    if(!options.logo){
        if(barsData.source){
            const source = svg.append('text')
                .style("font-weight", "400")
                .style("text-anchor", "middle")
                .style("font-family", options.fontFamily || "TheMix")
                .style("font-size", "14px")
                .style("fill", "#00183a")
                .attr("x", margin.left + width / 2)
                .attr("y", 553);
            source.append('tspan')
                .style('font-weight', '800')
                .style("font-size", "14px")
                .text('Quelle: ');
            source.append('tspan')
                .style("font-size", "14px")
                .text(barsData.source);
        }
    }
    else{
        const sourceImage = options.logo;
        svg.append(sourceImage.type)
            .attr("x",sourceImage.x)
            .attr("y",sourceImage.y)
            .attr("href", sourceImage.href)
            .style("width",sourceImage.width)
            .style("width",sourceImage.height)
            .call(addStyle, sourceImage.style);
    }


    if(!options || !options.logo){
        svg.append('text')
            .style("font-weight", "400")
            .style("text-anchor", "start")
            .style("font-family", options.fontFamily || "TheMix")
            .style("font-size", "14px")
            .style("fill", "#00183a")
            .attr("x", margin.left + width - 160)
            .attr("y", 553)
            .text('infratest dimap')

        svg.append('image')
            .attr('href', 'resources/SWR_Logo_RGB_Weiss.svg')
            .attr("x", margin.left + width - 58)
            .attr("y", 540)
            .style("width", "auto")
            .style("height", "14px");
    }
    else{
        const sourceImage = options.source;
        svg.append(sourceImage.type)
            .attr("x",sourceImage.x)
            .attr("y",sourceImage.y)
            .attr("href", sourceImage.href)
            .style("width",sourceImage.width)
            .style("width",sourceImage.height)
            .call(addStyle, sourceImage.style ||{});
    }


    barGroup
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("width", x.bandwidth())
        .attr("fill", (d) => getColor(d.color))
        .attr("x", function (d) {
            return x(d.name);
        })
        .attr("y", function (d) {
            return height;
        })
        .attr("height", function (d) {
            return 0;
        })
        .transition() // <---- Here is the transition
        .duration(300) // 2 seconds
        .delay(function (d, i) {
            return i * 300;
        })
        .attr("y", function (d) {
            return y(d.value);
        })
        .attr("height", function (d) {
            return height - y(d.value);
        });

    barGroup
        .append("rect")
        .attr("x", 0)
        .attr("y", height + axisOffset)
        .attr("width", width)
        .attr("height", 50)
        .attr("fill", "#555")
        .call(addStyle,options.legend.label.bar ||{});

    const percentBar = barGroup.select('percent-group').node() ?barGroup.select('percent-group') : barGroup.append('g')
        .attr('class', 'percent-group')
        .attr('transform', "translate(" + 0 + "," + (height + axisOffset + 50) + ")");

    percentBar
        .append("rect")
        .attr("width", width)
        .attr("height", 40)
        .attr("fill", "#FFFFFF")
        .call(addStyle,options.legend.value.bar ||{});

    percentBar
        .selectAll("text")
        .data(data)
        .enter()
        .append("text")
        .attr("x", function (d) {
            return x(d.name) + x.bandwidth() / 2;
        })
        .attr("y", function (d) {
            return 40 - 12;
        })
        .call(addStyle, layoutStyles.labels)
        .text(function (d) {
            return strToLocale(d.value.toFixed(1));
        }).call(addStyle,options.legend.value.text ||{});

    const diffBar = barGroup.select('g.diff-group').node() ? barGroup.select('g.diff-group') : barGroup.append('g')
        .attr('class', 'diff-group')
        .attr('transform', "translate(" + 0 + "," + (height + axisOffset + 50 + 40 + 4) + ")");

    diffBar
        .append("rect")
        .attr("width", width)
        .attr("height", 40)
        .attr("fill", "#FFFFFF");
    diffBar
        .selectAll("text.diff")
        .data(data)
        .enter()
        .append("text")
        .attr('class', '.diff')
        .attr("x", function (d) {
            return x(d.name) + x.bandwidth() / 2;
        })
        .attr("y", 40 - 12)
        .call(addStyle, layoutStyles.labels)
        .call(addStyle,options.legend.value.text ||{})
        .text(function (d) {
            return d.difference > 0 ? '+'+strToLocale(d.difference.toFixed(1)):strToLocale(d.difference.toFixed(1));
        });

    barGroup
        .selectAll("bottomBars")
        .data(data)
        .enter()
        .append("rect")
        .attr("x", function (d) {
            return x(d.name);
        })
        .attr("y", function (d) {
            return height + axisOffset;
        })
        .attr("width", x.bandwidth())
        .attr("height", 16)
        .attr("fill", (d) => getColor(d.color));

    barGroup
        .selectAll("bottomBars")
        .data(data)
        .enter()
        .append("text")
        .style("font-weight", "400")
        .style("text-anchor", "middle")
        .attr("x", function (d) {
            return x(d.name) + x.bandwidth() / 2;
        })
        .attr("y", function (d) {
            return height + axisOffset + 40;
        })
        .attr("font-family", options.fontFamily || "TheMix")
        .attr("font-size", "20px")
        .attr("fill", "white")
        .call(addStyle,options.legend.label.text ||{})
        .text(function (d) {
            return d.name;
        });

    return function update(data, diff) {
        const max = data.reduce((old, item) => (item.value > old ? item.value : old), 0);

        const y = d3.scaleLinear().domain([0, max]).range([height, 0]);

        // hideDiff
        if(diff){
            const diffBar = barGroup.select('g.diff-group').node() ? barGroup.select('g.diff-group') : barGroup.append('g')
                .attr('class', 'diff-group')
                .attr('transform', "translate(" + 0 + "," + (height + axisOffset + 50 + 40 + 4) + ")");

            diffBar
                .append("rect")
                .attr("width", width)
                .attr("height", 40)
                .attr("fill", "#FFFFFF");
            diffBar
                .selectAll("text.diff")
                .data(data)
                .enter()
                .append("text")
                .attr('class', '.diff')
                .attr("x", function (d) {
                    return x(d.name) + x.bandwidth() / 2;
                })
                .attr("y", 40 - 12)
                .call(addStyle, layoutStyles.labels)
                .text(function (d) {
                    return d.difference > 0 ? '+'+strToLocale(d.difference.toFixed(1)):strToLocale(d.difference.toFixed(1));
                });
        }
        else{
            barGroup.select('.diff-group').attr('opacity', 1).transition().duration(1000).attr('opacity', 0).remove();
        }
        const percentBar = barGroup.select('percent-group').node() ?barGroup.select('percent-group') : barGroup.append('g')
            .attr('class', 'percent-group')
            .attr('transform', "translate(" + 0 + "," + (height + axisOffset + 50) + ")");

        percentBar
            .append("rect")
            .attr("width", width)
            .attr("height", 40)
            .attr("fill", "#FFFFFF");

        percentBar
            .selectAll("text")
            .data(data)
            .enter()
            .append("text")
            .attr("x", function (d) {
                return x(d.name) + x.bandwidth() / 2;
            })
            .attr("y", function (d) {
                return 40 - 12;
            })
            .call(addStyle, layoutStyles.labels)
            .text(function (d) {
                return strToLocale(d.value.toFixed(1));
            });
        barGroup
            .selectAll(".bar")
            .data(data)
            .transition() // <---- Here is the transition
            .duration(500) // 2 seconds
            .attr("y", function (d) {
                return y(d.value);
            })
            .attr("height", function (d) {
                return height - y(d.value);
            });

    }

    function getColor(color) {
        return colors[color];
    }
}
